import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ChangePasswordModel } from '@core/services/auth/auth.model';
import { AuthService } from '@core/services/auth/auth.service';
import { LocalStorageService } from '@core/services/local-storage/local-storage.service';
import { NavigationService } from '@core/services/navigation.service';
import { mustMatchValidator } from '@shared/directives/must-match.directive';

@Component({
  selector: 'Teranet-UserPasswordChange',
  templateUrl: './user-password-change.component.html'
})
export class UserPasswordChangeComponent implements OnInit {
  changePasswordForm: FormGroup;
  changePasswordModel: ChangePasswordModel;
  status;
  errorMessage: Array<string> = [];
  isError: boolean;
  isPasswordWeak: boolean = false;
  previousUrl: string;

  constructor(private authService: AuthService, private localStorageService: LocalStorageService, private router: Router, private fb: FormBuilder, private navigation: NavigationService) { }

  ngOnInit() {
    this.changePasswordModel = new ChangePasswordModel();
    this.changePasswordForm = this.fb.group(
      {
        'username': new FormControl({ value: this.localStorageService.getItem('currentUser') ? this.localStorageService.getItem('currentUser').username : "", disabled: true }),
        'oldpassword': new FormControl('', Validators.required),
        'newpassword': new FormControl('', Validators.compose([Validators.required, Validators.minLength(10)])),
        'confirmpassword': new FormControl('', Validators.compose([Validators.required]))
      },
      {
        validator: mustMatchValidator('newpassword', 'confirmpassword')
      });
  }

  onCancel() {
    this.navigation.back();
  }

  OnSubmit() {
    this.isError = null;
    this.errorMessage = [];
    this.isPasswordWeak = false;
    if (this.changePasswordForm.valid) {
      this.authService.changePassword(this.changePasswordModel).subscribe(x => {
        this.isError = false;
        setTimeout(() => {
          this.router.navigate(['login']);
        }, 5000);
      },
        (err: HttpErrorResponse) => {
          this.isError = true;
          if (this.isIterable(err.error)) {
            for (var item of err.error) {
              if (!this.isPasswordWeak && item.code !== "PreviousPassword") {
                this.isPasswordWeak = true;
              }
              this.errorMessage.push(item.description);
            }
          }
          else {
            this.errorMessage.push(err.error.errors.NewPassword);
          }
        });
    }
  }

  isIterable(obj) {
    if (obj == null) {
      return false;
    }
    return typeof obj[Symbol.iterator] === 'function';
  }
}
